import { useState } from 'react';
import { LoadingSpinner } from '@lib/common';
import { useHeadingEditing, useHeadingForm } from './hooks';
import { CardLayout, CardTitle, CardDescription, CardActions, StyledCardContainer } from '../shared';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HeadingV2Preview = function HeadingV2Preview(_ref) {
  var _heading$id;

  var heading = _ref.heading,
      selectedFormItemId = _ref.selectedFormItemId,
      headingLabel = _ref.headingLabel,
      _ref$readonly = _ref.readonly,
      readonly = _ref$readonly === void 0 ? false : _ref$readonly,
      isFocusedHeading = _ref.isFocusedHeading,
      onSelectedHeading = _ref.onSelectedHeading,
      handleGetPositionElement = _ref.handleGetPositionElement,
      onEditHeading = _ref.onEditHeading,
      onDeleteHeading = _ref.onDeleteHeading,
      editorLabels = _ref.editorLabels,
      isAiMode = _ref.isAiMode,
      _onMention = _ref.onMention;

  var _useState = useState(),
      openPopoverHeadingId = _useState[0],
      setOpenPopoverHeadingId = _useState[1];

  var _useState2 = useState(false),
      isHeadingEditMode = _useState2[0],
      setIsHeadingEditMode = _useState2[1]; // Hooks


  var editing = useHeadingEditing({
    heading: heading,
    headingLabel: headingLabel,
    readonly: true,
    onUpdateHeading: undefined
  });
  var form = useHeadingForm({
    heading: heading,
    localTitle: editing.localTitle,
    localDescription: editing.localDescription,
    headingLabel: headingLabel,
    onUpdateHeading: undefined,
    isEditing: false
  });

  if (!heading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }

  var headingId = (heading === null || heading === void 0 ? void 0 : (_heading$id = heading.id) === null || _heading$id === void 0 ? void 0 : _heading$id.toString()) || '';
  var isFocused = selectedFormItemId === headingId;

  var handleEditClick = function handleEditClick() {
    onEditHeading === null || onEditHeading === void 0 ? void 0 : onEditHeading(headingId);
  };

  var handleSave = function handleSave() {
    editing.handleDescriptionSave();
    setIsHeadingEditMode(false);
  };

  var handleCancel = function handleCancel() {
    setIsHeadingEditMode(false);
    editing.handleDescriptionCancel();
  };

  return /*#__PURE__*/_jsxs(CardLayout, {
    isFocused: isFocusedHeading || isFocused,
    onClick: function onClick() {
      return onSelectedHeading === null || onSelectedHeading === void 0 ? void 0 : onSelectedHeading(headingId);
    },
    sectionId: headingId,
    formProps: {
      form: form.form,
      name: 'heading',
      initialValues: form.initialValues,
      onFieldsChange: form.onFieldsChange
    },
    onGetPositionElement: handleGetPositionElement,
    children: [/*#__PURE__*/_jsxs(StyledCardContainer, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        tagLabel: (headingLabel === null || headingLabel === void 0 ? void 0 : headingLabel.heading) || 'HEADING',
        title: editing.localTitle,
        isEditing: isHeadingEditMode,
        isReadonly: readonly,
        placeholder: headingLabel === null || headingLabel === void 0 ? void 0 : headingLabel.placeholderHeadingTitle,
        onChange: function onChange(e) {
          return editing.handleTitleChange(e);
        },
        onBlur: editing.handleTitleBlur,
        onFocus: editing.handleTitleFocus,
        onKeyDown: editing.handleTitleKeyDown,
        onClick: editing.handleTitleFocus,
        autoFocus: isHeadingEditMode
      }), !readonly && /*#__PURE__*/_jsx(CardActions, {
        isOnlyRemainingSection: false,
        onEdit: function onEdit(e) {
          e === null || e === void 0 ? void 0 : e.stopPropagation();
          handleEditClick();
        },
        onDelete: function onDelete(e) {
          e === null || e === void 0 ? void 0 : e.stopPropagation();
          onDeleteHeading === null || onDeleteHeading === void 0 ? void 0 : onDeleteHeading(headingId);
        },
        openPopoverId: openPopoverHeadingId,
        onPopoverChange: setOpenPopoverHeadingId,
        sectionId: headingId,
        actions: ['edit', 'mention', 'delete'],
        isAiMode: isAiMode,
        onMention: function onMention(e) {
          e === null || e === void 0 ? void 0 : e.stopPropagation();
          _onMention === null || _onMention === void 0 ? void 0 : _onMention();
        }
      })]
    }), /*#__PURE__*/_jsx(CardDescription, {
      description: editing.localDescription,
      isEditing: isHeadingEditMode,
      isReadonly: readonly,
      placeholder: headingLabel === null || headingLabel === void 0 ? void 0 : headingLabel.placeholderHeadingDescription,
      onChange: editing.handleDescriptionChange,
      onSave: handleSave,
      onCancel: handleCancel,
      saveLabel: headingLabel === null || headingLabel === void 0 ? void 0 : headingLabel.saveHeading,
      cancelLabel: headingLabel === null || headingLabel === void 0 ? void 0 : headingLabel.cancel,
      editorLabels: editorLabels
    })]
  });
};